import { useEffect } from "react";

/**
 * Mirrors a payment form's in-flight state onto its wizard, which owns the
 * locking of shared inputs and of the modal's exit routes. Clears on unmount so
 * a view that leaves mid-flight cannot strand the modal shut.
 */
export const useReportSubmitting = (
  isSubmitting: boolean,
  setSubmitting: (submitting: boolean) => void,
) => {
  useEffect(() => {
    setSubmitting(isSubmitting);

    return () => setSubmitting(false);
  }, [isSubmitting, setSubmitting]);
};
